import { QueryClient } from '@tanstack/react-query'
import { shouldRetryQuery } from '@/lib/trpc-errors'

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30 * 1000,
        // The rule itself lives in `lib/trpc-errors.ts`, beside the predicates
        // it is built from — a surface needing a stricter one composes with it
        // rather than restating it, because a per-query `retry` REPLACES this
        // one outright. See its docblock for what each exclusion costs.
        retry: shouldRetryQuery,
      },
    },
  })
}
